<template>
  <div>
    <section class="cost-section payable now">
      <table>
        <tbody>
          <tr>
            <td>
              <translate tag="strong"> Deposit </translate>
            </td>
            <td>
              <pu-price :price="deposit" :display-original-price="true" />
            </td>
          </tr>
          <tr class="info">
            <td colspan="2">
              <p>
                <translate>
                  Pitchup.com will bill you the deposit now.
                </translate>
                <translate tag="span" :tt="{ depositPercent }">
                  This is a {depositPercent, number, percent} non-refundable
                  deposit.
                </translate>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <section class="cost-section payable later">
      <table>
        <tbody>
          <tr>
            <td>
              <translate tag="strong"> Balance </translate>
            </td>
            <td>
              <pu-price :price="remainder" :display-original-price="true" />
            </td>
          </tr>
          <tr class="info">
            <td colspan="2">
              <p>
                <translate v-if="balancePayableOnArrive" :tt="{ campsiteName }">
                  The remainder is payable direct to {campsiteName} on arrival.
                </translate>
                <translate
                  v-if="balancePayableDirectly"
                  :tt="{ balanceDueDate }"
                >
                  The remainder is payable directly to the site by
                  {balanceDueDate, puDate, short}.
                </translate>
                <translate v-if="balancePayableOnSite">
                  The remainder is payable directly to the site as soon as
                  possible.
                </translate>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { MoneyType as Money } from '~/utility/money'

@Component
class BookingPaymentPitchupOnly extends Vue {
  @Prop()
  campsiteName: string

  @Prop()
  deposit: Money

  @Prop()
  remainder: Money

  @Prop()
  balanceDueDate: string

  @Prop()
  refundUntilDate: string

  @Prop()
  paymentTiming: string

  @Prop({ required: true })
  depositPercent: number

  get balancePayable(): string {
    if (this.paymentTiming === 'arrive') {
      return 'onArrive'
    } else if (this.balanceDueDate) {
      return 'directly'
    } else {
      return 'onSite'
    }
  }

  get balancePayableDirectly(): boolean {
    return this.balancePayable === 'directly'
  }

  get balancePayableOnArrive(): boolean {
    return this.balancePayable === 'onArrive'
  }

  get balancePayableOnSite(): boolean {
    return this.balancePayable === 'onSite'
  }
}

export default toNative(BookingPaymentPitchupOnly)
</script>
